export const range = (start: number, end: number, step = 1): number[] => {
  return Array(Math.ceil((end - start + 1) / step)).fill(start).map((val, index) => val + index * step)
}
